import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../authProvider";

export default function InitialRedirect() {
  const { user } = useAuthStore();

  if (user?.isClientRelated) {
    return <Navigate to="/profile" />;
  }

  return <Navigate to="/brands" />;
}
